import { render, staticRenderFns } from "./RoleAccessEdit.vue?vue&type=template&id=6d3f0b4c&scoped=true&"
import script from "./RoleAccessEdit.vue?vue&type=script&lang=js&"
export * from "./RoleAccessEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3f0b4c",
  null
  
)

export default component.exports